import { ImageFragment } from "../../fragments/image";
import { gql } from "@apollo/client";

//QUERY_LEADERSHIP_WHEEL
export const QUERY_LEADERSHIP_WHEEL = gql`
  query leadershipWheel {
    leadershipWheel: leadershipWheels_connection {
      data {
        id
        attributes {
          typeSection {
            mainGradientFrom
            mainGradientTo
            secondaryGradientFrom
            secondaryGradientTo
            tertiaryGradientFrom
            tertiaryGradientTo
          }
          focusArea
          description

          subFocusArea {
            focusArea
            description
            microExercisePrompt {
              title
              documentId
              publishedAt
              type
              content
            }
          }
          overallMoodIcon {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
`;

//QUERY_LEADERSHIP_WHEEL_PAGE
export const QUERY_LEADERSHIP_WHEEL_PAGE = gql`
  query leadershipWheelPage {
    leadershipWheelPage {
      data {
        attributes {
          relatedContentTitle
          howAreYouFeelingTitle
          youAreTitle
          howAreYouTitle
          changeMyAnswerCta
          wellDoneTitle
          goToYourMoodTracker
          resetTheWheel
          messages {
            initial
            trait
            subTrait
            initialTitle
            traitTitle
            subTraitTitle
            privacyStatement
          }
          onboarding {
            steps {
              title
              description
              textBtn
              image {
                data {
                  ...ImageFragment
                }
              }
            }
          }
          calendarTitle
          bottomText
          traitDetailsTitle
          TraitNotFound {
            finalState {
              course {
                data {
                  attributes {
                    slug
                  }
                }
              }
              knowledgeBase {
                data {
                  attributes {
                    slug
                  }
                }
              }
              redirectToCurrentCharacterExercise
              redirectToCalendar
              redirectToCalendar
            }
            text
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
